import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IUser} from '../../models/auth';
import {GenderEnum} from '../../models/user';

@Component({
  selector: 'app-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss']
})
export class AvatarGroupComponent implements OnInit {
  @Input() users: IUser[] = [];
  @Input() numberVisibleElements = 4;
  @Input() selectable: boolean;
  @Output() userSelected: EventEmitter<IUser> = new EventEmitter<IUser>();
  colors: string[] = [];
  constructor() { }

  ngOnInit(): void {
    this.colors = [
      '#f3a683',
      '#f7d794',
      '#778beb',
      '#e77f67',
      '#cf6a87',
      '#f19066',
      '#f5cd79',
      '#546de5',
      '#e15f41',
      '#c44569',
      '#786fa6',
      '#f8a5c2',
      '#63cdda',
      '#ea8685',
      '#574b90',
      '#f78fb3',
      '#3dc1d3',
      '#e66767',
      '#D6A2E8',
      '#BDC581',
      '#FC427B'
    ];
  }

  /**
   * Emite al componente padre cuando se selecciona un usuario
   * @param user usuario
   */
  onEmitUserSelected(user: IUser): void {
    if (user && user._id && this.selectable) {
      this.userSelected.emit(user);
    }
  }

  /**
   * En caso de un error al cargar la imagen del usuario, se intenta agregar otra
   * de acuerdo a su tipo de usuario y su género.
   * @param userId id del usuario
   * @param userType tipo de usuario
   */
  loadDefaultImage(userId: string, userType: 'patient' | 'expert' | 'not-defined'): void {
    const indexUserToChangeSrc = this.users.findIndex(item => item._id === userId);
    if (indexUserToChangeSrc === -1) { return; }

    const user = this.users[indexUserToChangeSrc];
    const defaultImage = './assets/images/icons/default-user.png';

    this.users[indexUserToChangeSrc].profileImageURL = (userType === 'patient' ?
      (
        user.gender ?
          (user.gender === GenderEnum.MALE ? './assets/images/icons/icons8-user-100.png' :
            user.gender === GenderEnum.FEMALE ? './assets/images/icons/icons8-lady-100.png' : defaultImage) : defaultImage
      ) :
      userType === 'expert' ?
        (
          user.gender ?
            (user.gender === GenderEnum.MALE ? './assets/images/icons/icons8-doctor-male-100.png' :
              user.gender === GenderEnum.FEMALE ? './assets/images/icons/icons8-doctor-female-100.png' : defaultImage) : defaultImage
        ) : defaultImage);
  }
}
